import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IEditBuyerUserProfileClient,
} from 'interfaceAdapter/gatewaySchemas/IEditBuyerUserProfileClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

const PATH = `${API_LOCATION_URL}/buyer/edit/user_profile`;

export class EditBuyerUserProfileClient implements IEditBuyerUserProfileClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, buyer_user } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify(buyer_user);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
